{
  "basicInfoFields": {
    "max": "姓は50文字以下で入力してください",
    "max2": "名は50文字以下で入力してください",
    "katakana": "セイは全角カタカナで入力してください",
    "max3": "セイは50文字以下で入力してください",
    "katakana2": "メイは全角カタカナで入力してください",
    "max4": "メイは50文字以下で入力してください",
    "enqueueSnackbar": "基本情報を更新しました",
    "enqueueSnackbar2": "基本情報の更新に失敗しました",
    "label": "姓",
    "label2": "名",
    "label3": "セイ",
    "label4": "メイ"
  },
  "emailFields": {
    "required": "メールアドレスを入力してください",
    "email": "正しいメールアドレスを入力してください",
    "message": "同じメールアドレスのアカウントがすでに存在します",
    "enqueueSnackbar": "確認コードを送信しました",
    "enqueueSnackbar2": "確認コードの送信に失敗しました",
    "label": "メールアドレス",
    "text": "更新すると確認のために新しいメールアドレスに確認コードを送信します。",
    "text2": "確認が完了するまで新しいメールアドレスは有効になりません。",
    "samlLocked": "SSOを有効にしているテナントでは、メールアドレスを変更できません。変更が必要な場合は、管理者にお問い合わせください。"
  },
  "loginNotificationFields": {
    "enqueueSnackbar": "テナント情報を取得できません",
    "enqueueSnackbar2": "ログインお知らせメール設定を更新しました",
    "enqueueSnackbar3": "ログインお知らせメール設定の更新に失敗しました",
    "text": "ログイン時にメールアドレス宛にお知らせメールを送信する（不正ログイン対策）",
    "text2": "有効にすると、ログイン時にメールでお知らせが届きます"
  },
  "passwordFields": {
    "required": "現在のパスワードを入力してください",
    "required2": "新しいパスワードを入力してください",
    "enqueueSnackbar": "パスワードを更新しました。新しいパスワードで再度ログインしてください。",
    "enqueueSnackbar2": "パスワードの更新に失敗しました",
    "label": "現在のパスワード",
    "label2": "新しいパスワード"
  },
  "accountSettings": {
    "label": "基本情報",
    "label2": "メールアドレス",
    "label3": "パスワード",
    "label4": "お知らせ",
    "title": "アカウント設定",
    "text": "更新中...",
    "title2": "アカウント情報"
  },
  "verificationCodeForm": {
    "required": "認証コードを入力してください",
    "enqueueSnackbar": "メールアドレスを更新しました",
    "message": "確認コードが間違っています",
    "message2": "試行回数の上限を超えました。しばらくしてからお試しください。",
    "message6": "同じメールアドレスのアカウントがすでに存在します",
    "enqueueSnackbar2": "メールアドレスの更新に失敗しました",
    "text": "メールアドレス確認コードを入力",
    "text2": "新しいメールアドレス宛に確認コードを送信しました。",
    "text3": "確認コードの有効期限は、24時間です。",
    "text4": "確認",
    "samlLocked": "SSOを有効にしているテナントでは、メールアドレスを変更できません。変更が必要な場合は、管理者にお問い合わせください。"
  }
}
